import React from "react";

/**
 * The designed empty state.
 *
 * R6 is the whole reason this exists as a component rather than as prose in
 * each surface: "If a surface has no data behind it, render the designed empty
 * state. Do not fabricate plausible numbers, do not ship the mockup's hardcoded
 * strings." Every stub in `routes/` renders this, so the flag-on shell shows an
 * honest empty room rather than a mockup's invented one.
 *
 * §11.4 calls Empty the weakest of the nine universal states and Step 1 owns
 * completing them in `cipher.css`. This is the shell's use of it and is styled
 * from `.state` there; the local rules in `shell.css` are fallbacks only, so
 * nothing here overrides Step 1's work when it lands.
 */
export default function EmptyState({ title, detail, action }) {
  return (
    <div className="state state-empty" role="status">
      <div className="state-empty-title">{title}</div>
      {detail ? <div className="state-empty-detail dim">{detail}</div> : null}
      {action ? <div className="state-empty-action">{action}</div> : null}
    </div>
  );
}
